const NS = 'PodcastListingPage';
const CLS = 'podcastListingPage';

export class PodcastListingPage {
	constructor(element) {
		this.element = element;
		this.element.addEventListener('play', (e) => {
			let audios = document.getElementsByTagName('audio');
			for(let i = 0; i < audios.length; i++) {
				if(audios[i] != e.target) {
					audios[i].pause();
				}
			}
		}, true);
	}
}
